<template>
  <div class="mt-[-1px] h-full flex flex-col">
    <!-- 样式切换：亮屏和息屏 -->
    <ThemeExchange class="flex-shrink-0" />

    <!-- 样式列表 -->
    <ThemeList id="themeTree" class="mb-2.5 flex-1" />

    <!-- 图层面板 -->
    <LayerPanel class="flex-[3]" />
  </div>
</template>

<script setup lang="ts"></script>
